module.exports = __webpack_public_path__ + "static/media/join-us-group-10@3x.dbdf39b8.png";